import React, {Component} from "react";
import BsyUserCont from "../BsyUserCont";
import BsyRoleCont from "../BsyRoleCont";
import BsyIconBtn from "../BsyIconBtn";
import BsyDomTree from '../BsyDomTree';
import BsyResignCont from "../BsyResignCont";
import './index.css';
import BsyAlertMenu from "../BsyAlertMenu";
import {BsyUtils} from "../../utils/Utils";
import BsyDialog from '../BsyDialog';
import Tree from "rc-tree";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import AddRole from "./AddRole";

export default class BsyUserManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      role: {},
      roles: [],
      treeData: [],
      editable: false,
      qywechat_expire: false,
      qywechat_expire_day: 0,
      qywechat_custom: false,
      qywechat_custom_url: '',
      deptRemove: false,
      hasUserRole: 1,
      success: false,
      selectKey: null,
      selectDept: null,
      selectRoleKey: null,
      selectRole: null,
      expandedKeys: ["1"],
    }
    this.refAllMember = React.createRef();
    this.resignItem = React.createRef();
  }

  componentDidMount() {
    this.getRoleList(this.getDeptList, true);
  }

  deepCopy = (obj, visited = new WeakMap()) => {
    // 如果 obj 是 null 或不是对象，直接返回它自身
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    // 如果 obj 已经被访问过，返回它的副本以避免循环引用
    if (visited.has(obj)) {
      return visited.get(obj);
    }

    // 根据 obj 的类型创建一个新的空对象或数组
    let copy;
    if (Array.isArray(obj)) {
      copy = [];
    } else {
      copy = Object.create(Object.getPrototypeOf(obj));
    }

    // 记录访问过的 obj，以便处理循环引用
    visited.set(obj, copy);

    // 遍历 obj 的属性或数组元素并进行递归深拷贝
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepCopy(obj[key], visited);
      }
    }

    return copy;
  }

  getDeptList = () => {
    React.axios('/corp/department/list', {}).then(res => {
      this.setState({departments: [...this.deepCopy(res.data.departments || [])], hasUserRole: 1, success: true})
      this.userContNode && this.userContNode.setDepartments(this.deepCopy(res.data.departments || []));
      this.domTreeContext && this.domTreeContext.updataTree && this.domTreeContext.updataTree(this.deepCopy(res.data.departments || []));
    }).catch(res => {

    })
  }

  getRoleDomTreeContext = (context) => {
    this.domRoleTreeContext = context
  }

  getRoleList = (cd, first) => {
    React.axios('/corp/role/list', {
      corpId: window.FX.Utils.getCurrentCorp()
    }).then(res => {
      const roles1 = [...res.data.roles];
      const roles2 = [...res.data.roles];
      let role = {};
      let flag = true;
      if (roles1.length > 0) {
        roles2.sort((a, b) => {
          return a.parent - b.parent
        })
        roles2.map(res1 => {
          if (res1.type === "0" && flag) {
            role = res1;
            flag = false;
          }
        })
      }
      if (first) {
        let expandedKeys = [];
        const getExpandedKeys = (targetId) => {
          roles1.map(res1 => {
            if (res1.role_id === targetId) {
              expandedKeys.push(res1.role_id);
              res1.parent !== 0 && getExpandedKeys(res1.parent);
            }
          })
        }
        role.parent && getExpandedKeys(role.parent)

        let newChild = this.transformToTreeFormat(this.deepClone(roles1));
        let child = [];
        let levelChild = 0;
        let treeData = newChild.map(res =>{
          return this.createTreeMenuData(res, levelChild, child)
        })
        this.setState({
          roles: [...roles1],
          treeData: treeData,
          expandedKeys,
          selectRoleKey: role.role_id,
          selectRole: role.role_id,
          editable: res.data.editable,
          role,
          hasUserRole: cd ? 1 : 0
        }, () => {
          cd && cd();
          this.domRoleTreeContext && this.domRoleTreeContext.handleNodeClick && this.domRoleTreeContext.handleNodeClick(role);
        })
      } else {
        let newChild = this.transformToTreeFormat(this.deepClone(roles1));
        let child = [];
        let levelChild = 0;
        let treeData = newChild.map(res =>{
          return this.createTreeMenuData(res, levelChild, child)
        })
        this.setState({
          treeData: treeData,
          roles: [...roles1],
          editable: res.data.editable,
          // role,
          hasUserRole: cd ? 1 : 0
        }, () => {
          cd && cd();
          this.domRoleTreeContext && this.domRoleTreeContext.handleNodeClick && this.domRoleTreeContext.handleNodeClick(role);
        })
      }
      this.userContNode && this.userContNode.setRoles(this.deepClone(roles1));
    }).catch(res => {

    })
  }

  organizationMenuBtn = (e) => {
    this.getDeptList()
  }

  onMemberSync = () => {
    this.AllMember();
    this.setState({
      deptId: null
    }, () => {
      this.getDeptList();

    })
  }

  roleMenuBtn = () => {
    this.getRoleList(null, true)
  }

  AllMember = () => {
    this.setState({
      deptId: null,
      selectDept: null
    }, () => {
      this.userContNode && this.userContNode.deptRefresh(null)
      this.refAllMember.current.classList.add('select');
      if (!BsyUtils.isSubAdmin())
        this.resignItem && this.resignItem.current && this.resignItem.current.classList.remove('select');
      this.setState({selectDept: null, hasUserRole: 1, selectKey: null})
      this.domTreeContext.setTreeKey(null)
    })
  }

  deptTreeNodeClick = (node) => {
    this.setState({
      deptId: node.departmentId,
      selectDepts: node
    }, () => {
      this.refAllMember.current.classList.remove('select');
      if (!BsyUtils.isSubAdmin())
        this.resignItem && this.resignItem.current && this.resignItem.current.classList.remove('select');
      this.setState({selectDept: node.departmentId, selectKey: node.key, hasUserRole: 1}, () => {
        this.userContNode && this.userContNode.deptRefresh(node)
      })
      // this.userContNode.setDepartments(this.state.departments);
    })
  }

  switchRoleItem = (node) => {
    this.setState({selectRole: node.role_id, selectRoleKey: node.key}, () => {
      this.userRoleNode.roleRefresh(node)
    })

  }

  roleItemOther = (val, event) => {
    event.stopPropagation()
    event.preventDefault();
    const t = window.$(event.currentTarget)
    const _this = this
    const {roles, editable} = this.state
    const targetRoleList = roles.filter(res => {
      res.value = res.role_id;
      res.text = res.name;
      return res.type === "1"
    });

    let menu = [{
      text: React.language('name.update'),
      icon: "",
      colorType: "",
      click: () => {
        window.FX.Msg.nAlter({
          renderEl: t,
          title: React.language("edit.role.name"),
          name: val.name,
          placeholder: React.language("name.placeholder"),
          onOk: function (c2) {
            var name = "";
            if (!!c2.checkValidate()) {
              name = c2.getValue();

              var result = {};
              if (!BsyUtils.checkValidateTitle(name, React.language('role.name'), result, 32)) {
                return !1;
              }

              window.FX.Utils.ajax({
                url: "/corp/role/rename",
                data: {
                  role_id: val.role_id,
                  name: name,
                  corpId: window.FX.Utils.getCurrentCorp()
                }
              }, function () {
                // l.close(),
                // k.close(),
                _this.getRoleList()
              }, function (e) {
                window.FX.Vip.showUpgradeTip(e.responseJSON)
              })
            }
          }
        })
      }
    }, {
      text: val.type === "1" ? React.language('Role.group.ID') : React.language('Role.ID'),
      icon: "",
      colorType: "",
      click: () => {
        window.FX.Msg.nAlter({
          renderEl: t,
          title: val.type === "1" ? React.language('Role.group.ID') : React.language("Role.ID"),
          name: val._id,
          mode: "show"
        })
      }
    }, {
      text: React.language('delete'),
      icon: "",
      colorType: "red",
      click: () => {
        window.FX.Msg.alert({
          type: "warning",
          title: React.language("contact.group.delete.confirm", {name: val.name}),
          msg: React.language("role.delete.tip"),
          onOk: function () {
            if(val.children && val.children.length > 0){
              tipAlert({
                type: "warning",
                msg: React.language("role.group.remove.tip")
              })
              return
            }
            window.FX.Utils.ajax({
              url: "/corp/role/" + val.role_id + "/remove",
              data: {
                corpId: window.FX.Utils.getCurrentCorp(),
              }
            }, function () {
              event.target.parentNode.parentNode.getElementsByClassName('select')[0] && event.target.parentNode.parentNode.getElementsByClassName('select')[0].classList.remove('select');
              if (event.target.parentNode.parentNode.getElementsByClassName('roleGroup-item')[0]) {
                event.target.parentNode.parentNode.getElementsByClassName('roleGroup-item')[0].classList.add('select');
                const roles1 = roles.filter(function (d) {
                  return d.role_id != val.role_id
                })
                if (roles1.length)
                  _this.userRoleNode.roleRefresh(roles1[0])

              }

              _this.getRoleList()
            }, function (e) {
              window.FX.Vip.showUpgradeTip(e.responseJSON)
            })
          }
        });
      }
    }];

    if (val.type === "1") {
      let menu1 = [{
        text: React.language('create.role'),
        colorType: "",
        click: () => {
          BsyDialog({
            title: React.language('create.role'),
            height: 443,
            width: 450,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onOk: () => {
              const {roleName} = this.addRoleContext;
              const {users} = this.addRoleContext.state;
              if (roleName.length === 0) {
                tipAlert({
                  type: "warning",
                  msg: React.language("role.name.notEmpty")
                });
                return false;
              } else if (roleName.length > 32) {
                tipAlert({
                  type: "warning",
                  msg: React.language("role.name.tooLong", {length: 32})
                });
                return false;
              }

              React.axios("/corp/role/create", {
                type: "0",
                parent: val.role_id,
                name: roleName,
                member: users
              }).then(res => {
                this.getRoleList();
                const {expandedKeys} = _this.state;
                if(expandedKeys.indexOf(val.role_id) < 0){
                  expandedKeys.push(val.role_id);
                }
                this.setState({expandedKeys: expandedKeys})
                tipAlert({
                  type: "success",
                  msg: React.language("api.CeateKey.success")
                });
              })
            },
            onContentCreate: () => {
              return <AddRole targetRoleList={targetRoleList} isAddChild={true} getContext={this.getAddRoleContext}/>
            }
          })
        }
      }, {
        text: React.language('create.role.group'),
        colorType: "",
        click: () => {
          let roleGroupName = "";
          BsyDialog({
            title: React.language('create.role.group'),
            height: 320,
            width: 450,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onOk: () => {
              if (roleGroupName.length === 0) {
                tipAlert({
                  type: "warning",
                  msg: React.language("role.group.name.notEmpty")
                });
                return false;
              } else if (roleGroupName.length > 32) {
                tipAlert({
                  type: "warning",
                  msg: React.language("role.group.name.tooLong", {length: 32})
                });
                return false;
              }

              React.axios("/corp/role/create", {
                type: "1",
                parent: val.role_id,
                name: roleGroupName
              }).then(res => {
                this.getRoleList();
                const {expandedKeys} = _this.state;
                if(expandedKeys.indexOf(val.role_id) < 0){
                  expandedKeys.push(val.role_id);
                }
                this.setState({expandedKeys: expandedKeys})
                tipAlert({
                  type: "success",
                  msg: React.language("api.CeateKey.success")
                });
              })
            },
            onContentCreate: () => {
              const onChangeRoleName = (event) => {
                roleGroupName = event.target.value;
              }
              return <div className="createRoleInput">
                <div className="item-title">
                  <b>*</b>
                  {React.language("corp.dingtalk.Step4.name")}
                </div>
                <input autoFocus={true} type="text" placeholder={React.language("role.group.name.placeholder")}
                       onChange={onChangeRoleName}/>
              </div>
            }
          })
        }
      }]
      menu = [...menu1, ...menu]
    }


    if (this.getRoleSync()) {
      menu = [{
        text: val.type === "1" ? React.language('Role.group.ID') : React.language('Role.ID'),
        icon: "",
        colorType: "",
        click: () => {
          window.FX.Msg.nAlter({
            renderEl: t,
            title: val.type === "1" ? React.language('Role.group.ID') : React.language("Role.ID"),
            name: val._id,
            mode: "show"
          })
        }
      }];
    } else {
      if (!editable) {
        menu = [{
          text: React.language('name.update'),
          icon: "",
          colorType: "",
          click: () => {
            window.FX.Msg.nAlter({
              renderEl: t,
              title: React.language("edit.role.name"),
              name: val.name,
              placeholder: React.language("name.placeholder"),
              onOk: function (c2) {
                var name = "";
                if (!!c2.checkValidate()) {
                  name = c2.getValue();

                  var result = {};
                  if (!BsyUtils.checkValidateTitle(name, React.language('role.name'), result, 16)) {
                    return !1;
                  }

                  window.FX.Utils.ajax({
                    url: "/corp/role/rename",
                    data: {
                      role_id: val.role_id,
                      name: name,
                      corpId: window.FX.Utils.getCurrentCorp()
                    }
                  }, function () {
                    // l.close(),
                    // k.close(),
                    _this.getRoleList()
                  }, function (e) {
                    window.FX.Vip.showUpgradeTip(e.responseJSON)
                  })
                }
              }
            })
          }
        }, {
          text: val.type === "1" ? React.language('Role.group.ID') : React.language('Role.ID'),
          icon: "",
          colorType: "",
          click: () => {
            window.FX.Msg.nAlter({
              renderEl: t,
              title: val.type === "1" ? React.language('Role.group.ID') : React.language("Role.ID"),
              name: val._id,
              mode: "show"
            })
          }
        }];
        if (val.type === "1") {
          let menu1 = [{
            text: React.language('create.role'),
            colorType: "",
            click: () => {
              BsyDialog({
                title: React.language('create.role'),
                height: 443,
                width: 450,
                noFooter: false,
                okText: React.language("ok"),
                cancelText: React.language("cancel"),
                onOk: () => {
                  const {roleName, targetRoleGroup} = this.addRoleContext;
                  const {users} = this.addRoleContext.state;
                  if (roleName.length === 0) {
                    tipAlert({
                      type: "warning",
                      msg: React.language("role.name.notEmpty")
                    });
                    return false;
                  } else if (roleName.length > 32) {
                    tipAlert({
                      type: "warning",
                      msg: React.language("role.name.tooLong", {length: 32})
                    });
                    return false;
                  }

                  React.axios("/corp/role/create", {
                    type: "0",
                    parent: val.role_id,
                    name: roleName,
                    member: users
                  }).then(res => {
                    this.getRoleList();
                    const {expandedKeys} = _this.state;
                    if(expandedKeys.indexOf(val.role_id) < 0){
                      expandedKeys.push(val.role_id);
                    }
                    this.setState({expandedKeys: expandedKeys})
                    tipAlert({
                      type: "success",
                      msg: React.language("api.CeateKey.success")
                    });
                  })
                },
                onContentCreate: () => {
                  return <AddRole targetRoleList={targetRoleList} isAddChild={true} getContext={this.getAddRoleContext}/>
                }
              })
            }
          }, {
            text: React.language('create.role.group'),
            colorType: "",
            click: () => {
              let roleGroupName = "";
              BsyDialog({
                title: React.language('create.role.group'),
                height: 320,
                width: 450,
                noFooter: false,
                okText: React.language("ok"),
                cancelText: React.language("cancel"),
                onOk: () => {
                  if (roleGroupName.length === 0) {
                    tipAlert({
                      type: "warning",
                      msg: React.language("role.group.name.notEmpty")
                    });
                    return false;
                  } else if (roleGroupName.length > 32) {
                    tipAlert({
                      type: "warning",
                      msg: React.language("role.group.name.tooLong", {length: 32})
                    });
                    return false;
                  }

                  React.axios("/corp/role/create", {
                    type: "1",
                    parent: val.role_id,
                    name: roleGroupName
                  }).then(res => {
                    this.getRoleList();
                    const {expandedKeys} = _this.state;
                    if(expandedKeys.indexOf(val.role_id) < 0){
                      expandedKeys.push(val.role_id);
                    }
                    this.setState({expandedKeys: expandedKeys})
                    tipAlert({
                      type: "success",
                      msg: React.language("api.CeateKey.success")
                    });
                  })
                },
                onContentCreate: () => {
                  const onChangeRoleName = (event) => {
                    roleGroupName = event.target.value;
                  }
                  return <div className="createRoleInput">
                    <div className="item-title">
                      <b>*</b>
                      {React.language("corp.dingtalk.Step4.name")}
                    </div>
                    <input autoFocus={true} type="text" placeholder={React.language("role.group.name.placeholder")}
                           onChange={onChangeRoleName}/>
                  </div>
                }
              })
            }
          }]
          menu = [...menu1, ...menu]
        }
      }
    }

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: event.target,
    })
  }

  addRoleContext = null;

  getAddRoleContext = (r) => {
    this.addRoleContext = r
  }

  createRoleGroup = (ev) => {
    const e = this;
    const {roles} = this.state;
    let event = ev.currentTarget;
    const targetRoleList = roles.filter(res => {
      res.value = res.role_id;
      res.text = res.name;
      return res.type === "1"
    });
    event.classList.add("hover");
    let menu = [{
      text: React.language('create.role'),
      colorType: "",
      click: () => {
        event.classList.add("hover");
        BsyDialog({
          title: React.language('create.role'),
          height: 443,
          width: 450,
          noFooter: false,
          okText: React.language("ok"),
          cancelText: React.language("cancel"),
          onOk: () => {
            const {roleName, targetRoleGroup} = this.addRoleContext;
            const {users} = this.addRoleContext.state;
            if (roleName.length === 0) {
              tipAlert({
                type: "warning",
                msg: React.language("role.name.notEmpty")
              });
              return false;
            } else if (roleName.length > 32) {
              tipAlert({
                type: "warning",
                msg: React.language("role.name.tooLong", {length: 32})
              });
              return false;
            }

            React.axios("/corp/role/create", {
              type: "0",
              parent: targetRoleGroup ? targetRoleGroup : 0,
              name: roleName,
              member: users
            }).then(res => {
              this.getRoleList();
              tipAlert({
                type: "success",
                msg: React.language("api.CeateKey.success")
              });
            })
          },
          onContentCreate: () => {
            return <AddRole targetRoleList={targetRoleList} getContext={this.getAddRoleContext}/>
          }
        })
      }
    }, {
      text: React.language('create.role.group'),
      colorType: "",
      click: () => {
        event.classList.add("hover");
        let roleGroupName = "";
        BsyDialog({
          title: React.language('create.role.group'),
          height: 320,
          width: 450,
          noFooter: false,
          okText: React.language("ok"),
          cancelText: React.language("cancel"),
          onOk: () => {
            if (roleGroupName.length === 0) {
              tipAlert({
                type: "warning",
                msg: React.language("role.group.name.notEmpty")
              });
              return false;
            } else if (roleGroupName.length > 32) {
              tipAlert({
                type: "warning",
                msg: React.language("role.group.name.tooLong", {length: 32})
              });
              return false;
            }

            React.axios("/corp/role/create", {
              type: "1",
              parent: 0,
              name: roleGroupName
            }).then(res => {
              this.getRoleList();
              tipAlert({
                type: "success",
                msg: React.language("api.CeateKey.success")
              });
            })
          },
          onContentCreate: () => {
            const onChangeRoleName = (event) => {
              roleGroupName = event.target.value;
            }
            return <div className="createRoleInput">
              <div className="item-title">
                <b>*</b>
                {React.language("corp.dingtalk.Step4.name")}
              </div>
              <input autoFocus={true} type="text" placeholder={React.language("role.group.name.placeholder")}
                     onChange={onChangeRoleName}/>
            </div>
          }
        })
      }
    }]

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: event,
      onClose: () => {
        event.classList.remove("hover");
      }
    })
    // eslint-disable-next-line no-unused-expressions

  }

  resignList = () => {
    if (!BsyUtils.isSubAdmin()) {
      this.resignItem && this.resignItem.current && this.resignItem.current.classList.add('select');
    }
    this.refAllMember.current.classList.remove('select');
    this.setState({selectDept: null, hasUserRole: 2})
  }

  getUserCont = (rel) => {
    this.userContNode = rel;
    this.setState({
      qywechat_expire: rel.state.userCont.qywechat_expire,
      qywechat_expire_day: rel.state.userCont.qywechat_expire_day,
      qywechat_custom: rel.state.userCont.qywechat_custom,
      qywechat_custom_url: rel.state.userCont.qywechat_custom_url,
      deptRemove: rel.state.userCont.deptRemove,
      memberInvite: rel.state.userCont.memberInvite,
      memberRemove: rel.state.userCont.memberRemove,
    })
  }

  getRoleCont = (rel) => {
    this.userRoleNode = rel
  }

  getRoleSync = (rel) => {
    //第三方是否开启角色同步

    if (!this.userContNode) {
      return false;
    }

    if (!this.userContNode.state.userCont) {
      return false;
    }

    return this.userContNode.state.userCont.role_sync;
  }

  openActiveQywechat = () => {
    new window.FX.QywechatBindPane()
  }

  openQywechatCustomUrl = () => {
    const {qywechat_custom_url} = this.state;
    BsyDialog({
      title: React.language('qiyewechat.custom'),
      height: 520,
      width: 550,
      noFooter: true,
      onContentCreate: () => {
        return <div className="qiyewechat-active">
          <div className="qiyewechat-content">
            <div className="qiyewechat-active-title">
              {React.language('qiyewechat.custom.active.code')}
            </div>
            <div className="qiyewechat-qrcode">
              <img src={qywechat_custom_url} alt=""/>
            </div>
            <div className="qiyewechat-active-title">
              {React.language('qiyewechat.custom.active.code2')}
            </div>
          </div>
        </div>
      }
    })
  }

  getDomTreeContext = (context) => {
    this.domTreeContext = context
  }


  deletedData = false;
  addedData = false;
  fAddedData = false;
  changeSortData = (treeData, dragNode, parentId, departmentId, prev, expanded) =>{
    const updatedTree = treeData;
    if(parentId === updatedTree.role_id && !updatedTree.children){
      updatedTree.children = [];
      updatedTree.expanded = true;
      expanded.push(updatedTree.key);
    }
    if(updatedTree.children){
      if(prev === null){
        if(parentId === updatedTree.role_id && !this.fAddedData){
          const l = 0;
          this.addedData = true;
          this.fAddedData = true;
          updatedTree.children.splice(l, 0, dragNode);
          dragNode.isNew = true;
          dragNode.parentId = parentId;
          dragNode.parent = parentId;
          if(this.deletedData){
            this.deletedData = false;
            this.addedData = false;
          }
        }
      }
      for(let i = 0; i < (updatedTree.children ? updatedTree.children.length : 0); i++){
        if(updatedTree.children[i]){
          updatedTree.children[i] = this.changeSortData(updatedTree.children[i], dragNode, parentId, departmentId, prev, expanded);
        }
        if(updatedTree.children[i].role_id === dragNode.role_id && !updatedTree.children[i].isNew && !this.deletedData){
          updatedTree.children.splice(i, 1);
          this.deletedData = true;
          if (updatedTree.children.length === 0) {
            updatedTree.expanded = false;
            updatedTree.children = undefined;
            treeData.children = undefined;
            treeData.expanded = false;
            expanded.splice(expanded.indexOf(updatedTree.key), 1);
            i = 0;
          }else{
            i--;
          }

          if(this.addedData){
            this.deletedData = false;
            this.addedData = false;
          }
        }else{
          if(prev === null && parentId === updatedTree.children[i].role_id && !this.fAddedData){
            const l = 0;
            this.addedData = true;
            updatedTree.children[i].children.splice(l, 0, dragNode);
            dragNode.isNew = true;
            dragNode.parentId = parentId;
            dragNode.parent = parentId;
            i++;
            if(this.deletedData){
              this.deletedData = false;
              this.addedData = false;
            }
          }else if(updatedTree.children[i].role_id === prev && !this.fAddedData){
            const l = i + 1;
            this.addedData = true;
            updatedTree.children.splice(l, 0, dragNode);
            dragNode.isNew = true;
            dragNode.parentId = parentId;
            dragNode.parent = parentId;
            i++;
            if(this.deletedData){
              this.deletedData = false;
              this.addedData = false;
            }
          }
        }
      }
    }

    return updatedTree
  }

  findNode = (newTreeData, node) => {

    // let n = newTreeData.children.length;
    let result = {
      parentId: (newTreeData.dragOver || !newTreeData.dragOverGapBottom) ? newTreeData.role_id : newTreeData.parentId,
      role_id: node.role_id,
      prev: (newTreeData.dragOver || newTreeData.dragOverGapTop) ? null : !newTreeData.dragOverGapBottom ? (newTreeData.children && newTreeData.children.length > 0) ? newTreeData.children[newTreeData.children.length - 1].role_id : null : newTreeData.role_id,
    };
    return result;
  }

  handleMoveNode = (node) => {
    const { treeData, expandedKeys } = this.state;

    const result = this.findNode(node.node, node.dragNode);
    if (result.parentId === result.role_id) {
      // this.setState({ treeData: oldTreeData, expandedKeys: oldExpandedKeys });
      return;
    }

    if (node.node.type === "0"){
      result.parentId = node.node.parentId;
      result.prev = node.node.role_id;
    }

    if(node.dropPosition < 0){
      result.parentId = 0;
      result.prev = null;
    }

    let newData = {
      children: treeData,
      role_id: 0
    };
    const expanded = expandedKeys;
    const newData1 = this.changeSortData(newData,node.dragNode ,result.parentId, result.role_id, result.prev, expandedKeys)
    node.dragNode.isNew = false;
    this.fAddedData = false;
    this.setState({ expandedKeys: expanded, treeData: newData1.children }, () => {
      React.axios("/corp/role/sort", {
        parent: result.parentId,
        prev: result.prev,
        role_id: result.role_id
      }).then(res => {
        this.getRoleList();
      }).catch(res=>{
        this.getRoleList();
      })
    })
  }

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: "role_id",
      pIdKey: "parent"
    }
    var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'child';
    if (!e || "" == e || !b)
      return [];
    if (Array.isArray(b)) {
      var h = []
        , i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {

        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = [])


          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          i[b[c][f]][g].push(b[c])
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          h.push(b[c])
        }

      }
      return h
    }
    b.title = b.name;
    b.key = b[simpleData.idKey];
    return [b]
  }

  createTreeMenuData = (data, levelChild, child) => {
    let newData = {};

    BsyUtils.forEach(data, (key, val) => {
      if (key === "icon") {
        return
      }
      newData[key] = val;
    })
    newData.isLeaf = false;
    // newData.title = <></>;
    if (newData.type === "1") {
      newData.levelChild = levelChild;
      newData.parentId = data.parent;
      newData.key = data.role_id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.children = [];
      if (data.child && data.child.length > 0) {
        levelChild++;
        let newChlid = data.child.filter((string) => {
          return string
        })
        newData.children = newChlid.map(res => {
          return this.createTreeMenuData(res, levelChild, child)
        })
      }

    } else {
      newData.levelChild = levelChild;
      newData.key = data.role_id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.parentId = data.parent;
    }
    return newData;
  }

  deepClone = obj => {
    const isObject = args => (typeof args === 'object' || typeof args === 'function') && typeof args !== null
    if (!isObject) throw new Error('Not Reference Types')
    let newObj = Array.isArray(obj) ? [...obj] : { ...obj }
    Reflect.ownKeys(newObj).map(key => {
      newObj[key] = isObject(obj[key]) ? this.deepClone(obj[key]) : obj[key]
    })
    return newObj
  }

  newParentOverNode = null;
  startNode = null;

  render() {
    const {
      treeData,
      expandedKeys,
      selectRole,
      selectRoleKey,
      departments,
      selectDept,
      selectKey,
      hasUserRole,
      roles,
      editable,
      role,
      success,
      qywechat_expire,
      qywechat_expire_day,
      qywechat_custom,
      qywechat_custom_url,
      deptRemove,
      memberRemove
    } = this.state;
    let teamTitle = React.language("Normal.mode");
    let type = window.localDevInfo.user_corps.mode;
    if (type === "qyweixin") {
      teamTitle = React.language("wework");
    }
    if (type === "dingding") {
      teamTitle = React.language("dingtalk");
    }
    if (type === "feishu") {
      teamTitle = React.language("feishu");
    }
    if (type === "gzt") {
      teamTitle = React.language("gzt");
    }

    let emptyRole = false;

    roles.map(res => {
      if (res.type === "0") {
        emptyRole = true;
      }
    })

    return (
      <>
        {
          qywechat_custom && <div className="qywechat-custom-content">
            <div className="custom-tip">
              <i className="icon-bsy-laba"></i>
              <span>{React.language('qiyewechat.custom.tip')}</span>
            </div>
            <div className="custom-active-btn" onClick={this.openQywechatCustomUrl}>
              {React.language('qiyewechat.custom.active')}
            </div>
          </div>
        }
        {
          qywechat_expire && <div className="qywechat-expire-content">
            <div className="expire-tip">
              <i className="icon-bsy-laba"></i>
              <span>{React.language('qywechat.bind.activation.tip', {day: qywechat_expire_day})}</span>
            </div>
            <div className="expire-active-btn" onClick={this.openActiveQywechat}>
              {React.language('flow.action.activate')}
            </div>
          </div>
        }
        {
          success && <div className={"userCont " + window.mode}
                          style={{height: (qywechat_expire || qywechat_custom) ? 'calc(100% - 52px)' : ''}}>
            <div className="userMenu">
              <div className="teamTitle">
                {
                  React.language("team.model") + "：" + teamTitle
                }
              </div>
              <div className="teamTitleSplitLine"/>
              <div className={'teamType '}
                   key={'teamType'}
              >
                <BsyIconBtn
                  key={'organization' + new Date().getTime()}
                  text={React.language('organization')}
                  type={(hasUserRole === 1 || hasUserRole === 2) ? "newblue" : "white"}
                  hoverType={(hasUserRole === 1 || hasUserRole === 2) ? false : "borderBlue"}
                  click={this.organizationMenuBtn}
                  mode={window.mode}
                />
                <BsyIconBtn
                  key={'role' + new Date().getTime()}
                  text={React.language('role')}
                  click={this.roleMenuBtn}
                  type={(hasUserRole === 1 || hasUserRole === 2) ? "white" : "newblue"}
                  hoverType={(hasUserRole === 1 || hasUserRole === 2) ? "borderBlue" : false}
                  mode={window.mode}
                />
              </div>
              {(hasUserRole === 1 || hasUserRole === 2) && <div className="userMenuTree" key="userMenuTree">
                <div className="userTitle">
                  <span>{React.language('member')}</span>
                </div>
                <div className="teamAllMember select" onClick={(e) => this.AllMember()} ref={this.refAllMember}>
                  <i className='icon-all-user'/>
                  <span>{React.language('allMember')}</span>
                </div>
                <div className="userTitle">
                  <span>{React.language('department')}</span>
                </div>
                <div className='teamTree'>
                  <BsyDomTree departments={departments} domTreeContext={this.getDomTreeContext}
                              getDeptList={this.getDeptList} deptRemove={deptRemove} selectDept={selectDept}
                              selectKey={selectKey} nodeClick={(node) => this.deptTreeNodeClick(node)}/>
                </div>
                {
                  memberRemove ?
                    <div className="resignItem" ref={this.resignItem} onClick={this.resignList}>
                      <div className="icon-wrapper">
                        <i className="icon-bsy-reportmenu-9"/>
                      </div>
                      <span>
                          {

                            window.FX.STATIC.user_corps.mode && window.FX.STATIC.user_corps.mode === "common" ?
                              React.language('resign.user') : React.language('resign.user.1')
                          }
                      </span>
                    </div> : ''
                }
              </div>}
              {hasUserRole === 0 && <div className="roleMenuTree">
                {
                  this.getRoleSync() ? '' : editable ?
                    <div className="createRoleGroup">
                      <span>{React.language('handover.create.role')}</span>
                      <i className="icon-bsy-add" onClick={this.createRoleGroup}/>
                    </div> : ''
                }
                <div className="roleGroup">
                  {
                    roles.length > 0 ?
                      <Tree
                        treeData={treeData}
                        isVirtualized={false}
                        defaultExpandedKeys={[1]}
                        expandedKeys={[...new Set(expandedKeys)]}
                        selectedKeys={[selectRole]}
                        onClick={(e, node) => {
                          if(node.type === "1"){
                            return
                          }
                          this.switchRoleItem(node)
                        }}
                        onExpand={(expanded, node) => {
                          this.newParentOverNode = null;
                          if(node.node.type === "0"){
                            this.switchRoleItem(node.node)
                          }else{
                            if(!node.expanded){
                              const expandChild = (node) => {
                                node.map(res=>{
                                  let i = expandedKeys.indexOf(res.role_id);
                                  if(i > -1){
                                    expandedKeys.splice(expandedKeys.indexOf(res.role_id), 1);
                                  }
                                  res.children && expandChild(res.children)
                                })
                              }
                              expandedKeys.splice(expandedKeys.indexOf(node.node.role_id), 1);
                              node.node.children && expandChild(node.node.children)
                              this.setState({expandedKeys: expandedKeys})
                            }else{
                              this.setState({expandedKeys: expanded})
                            }

                          }
                        }}
                        onDragEnter={(node) => {
                          this.setState({expandedKeys: node.expandedKeys})
                        }}
                        draggable={true}
                        onDragOver={(node) => {
                          let n = node.node;
                          if (!this.newParentOverNode) {
                            this.newParentOverNode = node;
                          }
                          if (node.dropPosition < 0) {
                            window.FX.UI.closePopover()
                            return
                          }
                          if (this.newParentOverNode.node.key !== n.key || this.newParentOverNode.node.expanded !== n.expanded || this.newParentOverNode.node.dragOver !== n.dragOver) {
                            if(n.type === "0"){
                              const hp = BsyUtils.closestClass(document.getElementById(n._id), "rc-tree-node-content-wrapper");
                              hp.getElementsByClassName("rc-tree-line")[0] && (hp.getElementsByClassName("rc-tree-line")[0].style.left = 0);
                            }
                            if (n.levelChild < 1) {
                              window.FX.UI.closePopover()
                            }

                            if (this.sortTime) {
                              clearTimeout(this.sortTime);
                              this.sortTime = null;
                            }
                            if (n.type === "1") {
                              window.FX.UI.closePopover()
                              if (n.dragOver) {
                                window.FX.UI.showPopover({
                                  anchor: window.$(document.getElementById(n._id)),
                                  content: window.$("<span/>").text(React.language("role.edit.group.moveTo", {
                                    groupName: n.name
                                  })),
                                  type: "dark"
                                })
                              } else if(!n.expanded) {
                                this.sortTime = setTimeout(() => {
                                  node.context.triggerExpandActionExpand(node.event, n)
                                }, 1000)
                              }
                            }
                            this.newParentOverNode = node;
                          }
                        }}
                        onDrop={(node) => {
                          this.newParentOverNode = null;
                          this.startNode = null;
                          window.FX.UI.closePopover();
                          if (this.sortTime) {
                            clearTimeout(this.sortTime);
                            this.sortTime = null;
                          }
                          this.setState({isEnter: false});
                          this.handleMoveNode(node);
                        }}
                        onDragEnd={(node) => {
                          if (this.sortTime) {
                            clearTimeout(this.sortTime);
                            this.sortTime = null;
                          }
                          this.startNode = null;
                          window.FX.UI.closePopover()
                        }}
                        onDragStart={(node) => {
                          if (this.sortTime) {
                            clearTimeout(this.sortTime);
                            this.sortTime = null;
                          }
                          this.startNode = node;
                        }}
                        icon={(rowInfo) => {
                          return <>
                            <i className={`node-icon ${rowInfo.data.type === "0" ? "icon-role" : "icon-role-group"}`} id={rowInfo.data._id}/>
                            <i
                              className="icon-flow-other nav nav-department-edit"
                              style={{
                                verticalAlign: "middle"
                              }}
                              //自定义菜单点击
                              onClick={(e) => {
                                this.roleItemOther(rowInfo.data, e)
                              }}
                            ></i>
                          </>
                        }}
                        switcherIcon={(rowInfo) => {
                          let css = {
                            visibility: (rowInfo.data.children && rowInfo.data.children.length > 0) ? "" : "hidden"
                          };
                          if(rowInfo.levelChild === 0){
                            css = {
                              display: (rowInfo.data.children && rowInfo.data.children.length > 0) ? "" : "none"
                            };
                          }
                          return <>
                            {<i className={rowInfo.expanded ? 'icon-tree-collapse' : 'icon-tree-expand'} style={css}></i>}
                          </>
                        }}
                      />
                      : <div className="roleGroupEmpty">
                        {this.getRoleSync() ? React.language('role.empty.tip1') : React.language('role.empty.tip')}
                      </div>
                  }
                  {/*{*/}
                  {/*    roles.length > 0 ? roles.map((val, key) => {*/}
                  {/*        return <div key={val._id} className={key === 0 ? "roleGroup-item select" : "roleGroup-item"} onClick={this.switchRoleItem(val)}>*/}
                  {/*            <span>{val.name}</span>*/}
                  {/*            {*/}
                  {/*                <i className="icon-flow-other" onClick={this.roleItemOther(val)} />*/}
                  {/*            }*/}

                  {/*        </div>*/}
                  {/*    }) : <div className="roleGroupEmpty">*/}
                  {/*        {this.getRoleSync() ? React.language('role.empty.tip1') : React.language('role.empty.tip')}*/}
                  {/*    </div>*/}
                  {/*}*/}
                </div>
              </div>}
            </div>
            <div className="userContent">
              {hasUserRole === 1 &&
                <BsyUserCont selectDepts={this.state.selectDepts} deptId={this.state.deptId} roles={this.state.roles}
                             departments={this.state.departments} getUserCont={this.getUserCont}
                             onMemberSync={this.onMemberSync}/>}
              {hasUserRole === 2 && <BsyResignCont departments={this.state.departments}/>}
              {hasUserRole === 0 && <BsyRoleCont
                createRoleGroup={this.createRoleGroup}
                getRoleCont={this.getRoleCont}
                emptyRole={emptyRole}
                role={role}
                roleSync={this.getRoleSync()}
              />}
            </div>
          </div>
        }
      </>

    );
  }
}
